import { render, staticRenderFns } from "./HeForm.vue?vue&type=template&id=4bef06b2&scoped=true"
import script from "./HeForm.vue?vue&type=script&lang=js"
export * from "./HeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef06b2",
  null
  
)

export default component.exports